import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2, RefreshCw, XCircle } from 'lucide-react';
import api from '../api';
import { fmtDurata, fmtSize } from '../lib/produzione';

/**
 * Controllo specifiche dei media di pubblicazione (durata, formato, peso, risoluzione)
 * rispetto a formato e piattaforma della riga. `deps` ricarica il controllo quando cambia.
 */
export default function MediaCheck({ rid, deps = [] }) {
  const [esito, setEsito] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    if (!rid) return;
    setLoading(true);
    api.get(`/ped/${rid}/check_media`, { silent: true })
      .then(r => setEsito(r.data)).catch(() => setEsito(null)).finally(() => setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [rid, ...deps]);

  if (!esito || !esito.media?.length) return null;
  const ok = esito.blocchi === 0 && esito.avvisi === 0;

  return (
    <div style={{ marginTop: 14, borderRadius: 10, padding: '10px 12px',
      border: `1px solid ${esito.blocchi ? 'rgba(244,63,94,0.35)' : esito.avvisi ? 'rgba(245,158,11,0.35)' : 'rgba(16,185,129,0.3)'}`,
      background: esito.blocchi ? 'var(--red-dim)' : esito.avvisi ? 'var(--yellow-dim)' : 'var(--green-dim)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, fontWeight: 600,
        color: esito.blocchi ? 'var(--red)' : esito.avvisi ? 'var(--yellow)' : 'var(--green)' }}>
        {esito.blocchi ? <XCircle size={14} /> : esito.avvisi ? <AlertTriangle size={14} /> : <CheckCircle2 size={14} />}
        {esito.blocchi ? `Media non pubblicabile (${esito.blocchi} problema${esito.blocchi > 1 ? 'i' : ''})`
          : esito.avvisi ? 'Media pubblicabile, con avvisi' : 'Media conforme alle specifiche'}
        <button onClick={load} disabled={loading} title="Ricontrolla"
          style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', display: 'flex' }}>
          <RefreshCw size={13} style={loading ? { animation: 'eden-spin 0.7s linear infinite' } : undefined} />
        </button>
      </div>
      {!ok && esito.media.map((m, i) => (
        <div key={i} style={{ marginTop: 8, fontSize: 12 }}>
          {m.meta && (
            <div style={{ color: 'var(--text-muted)', marginBottom: 3 }}>
              {esito.media.length > 1 && <b style={{ color: 'var(--text)' }}>#{i + 1} · </b>}
              {m.meta.tipo === 'video' ? `Video ${fmtDurata(m.meta.durata_sec)}` : 'Immagine'}
              {m.meta.larghezza ? ` · ${m.meta.larghezza}×${m.meta.altezza} (${m.meta.ratio})` : ''} · {fmtSize(m.meta.peso)}
            </div>
          )}
          {m.problemi.map((p, j) => (
            <div key={j} style={{ display: 'flex', gap: 6, color: p.livello === 'blocco' ? 'var(--red)' : 'var(--yellow)' }}>
              • {p.testo}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
